import { cn } from '@repo/ui/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import React from 'react'

// Atom for creating a flex container of elements with a direction, alignment, and gap

type GapVariant = VariantProps<typeof stackVariants>['gap']

export type StackProps = React.HTMLAttributes<HTMLDivElement> & {
  direction?: VariantProps<typeof stackVariants>['direction']
  gap?: GapVariant | number
  align?: VariantProps<typeof stackVariants>['align']
}

const stackVariants = cva('flex', {
  variants: {
    direction: {
      row: 'flex-row',
      column: 'flex-col',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
    },
    gap: {
      none: 'gap-0',
      xs: 'gap-1',
      sm: 'gap-2',
      md: 'gap-4',
      lg: 'gap-6',
      xl: 'gap-8',
      '2xl': 'gap-12',
      '3xl': 'gap-16',
      '4xl': 'gap-24',
    },
  },
  defaultVariants: {
    direction: 'column',
    align: 'start',
    gap: 'none',
  },
})

export function Stack(props: StackProps) {
  const { direction, align, gap, className, ...rest } = props

  // Handle custom pixel gap
  const gapStyle = typeof gap === 'number' ? { gap: `${gap}px` } : undefined

  return (
    <div
      className={cn(
        stackVariants({
          direction,
          align,
          gap: typeof gap === 'string' ? (gap as GapVariant) : undefined,
        }),
        className,
      )}
      style={gapStyle}
      {...rest}
    />
  )
}
